// /app/frontend/src/index.js
// Frugal V2 - Entry Point

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './i18n'; // Initialize i18n for landing page
import './index.css';
import { installFetchTimezone } from './lib/fetchTimezone';

installFetchTimezone();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
